module.exports = __webpack_public_path__ + "static/bf-marie-015f67913f8c02c629f5971ca8dfd471.jpg";